
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./History.css";
import vision from "../assets/images/vision.jpeg"
import mission from "../assets/images/mission.jpeg"
const History = () => {
  useEffect(() => {
    const elements = document.querySelectorAll(
      ".history-page .animate-on-scroll"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show-animation");
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.12,
        rootMargin: "0px 0px -40px 0px",
      }
    );

    elements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, []);

  return (
    <main className="history-page">

      {/* HERO SECTION */}
      <section className="history-hero">
        <div className="container">
          <div className="history-hero-content">
            <h1>
              History of <span>the School</span>
            </h1>

            <p>
              A legacy of education, discipline, values and excellence.
            </p>

            <div className="history-breadcrumb">
              <Link to="/">Home</Link>
              <i className="bi bi-chevron-right"></i>
              <span>History of the School</span>
            </div>
          </div>
        </div>
      </section>

      {/* HISTORY CONTENT */}
      <section className="history-content-section section-space">
        <div className="container">

          <div className="history-heading text-center animate-on-scroll">
            <span className="history-label">
              <i className="bi bi-clock-history"></i>
              Our Heritage
            </span>
            <h2>
              History of <span>the School</span>
            </h2>
          </div>
<div className="history-timeline">
  <div className="text-center history-text animate-on-scroll animate-right">

    <p>
      Established in 1968, Air Force School, Vayu Sena Nagar,
      Nagpur, has a long-standing commitment to providing quality
      education and nurturing young minds. Located in Vayu Sena
      Nagar, Nagpur, the school has been serving the educational
      needs of children, particularly those from Air Force
      families, while welcoming students from other backgrounds
      in accordance with its admission policies.
    </p>

    <p>
      Over the years, the school has focused on creating a
      supportive and disciplined learning environment that
      promotes academic achievement, character building, and
      the all-round development of students. Following the
      Central Board of Secondary Education (CBSE) curriculum,
      the institution strives to provide a broad, balanced,
      and relevant education that prepares learners for future
      challenges.
    </p>

    <p>
      The school emphasises the importance of knowledge,
      integrity, responsibility, teamwork, and respect for
      others. Alongside classroom learning, students are
      encouraged to participate in sports, cultural programmes,
      creative pursuits, and other co-curricular activities
      that help develop confidence and leadership skills.
    </p>

    <p>
      With its enduring educational values and commitment to
      continuous improvement, Air Force School, Vayu Sena Nagar,
      Nagpur, continues to work towards shaping responsible
      citizens who contribute positively to society and uphold
      the values of excellence, discipline, and service.
    </p>

  </div>
</div>

        </div>
      </section>

      
    {/* VISION & MISSION SECTION */}
  <section className="history-purpose-section section-space">
  <div className="container">

    <div className="purpose-heading text-center animate-on-scroll">
      <span className="history-label">
        <i className="bi bi-stars"></i>
        Our Purpose & Direction
      </span>

      <h2>
        Guided by <span>Values & Vision</span>
      </h2>

      <p>
        The principles that inspire our journey and shape
        the future of our students.
      </p>
    </div>

    <div className="row g-4 align-items-stretch">

      {/* VISION CARD */}
      <div className="col-lg-6">
        <div className="purpose-card vision-purpose-card animate-on-scroll animate-left">

          <div className="purpose-content">
            <div className="purpose-card-top">
              <div className="purpose-icon vision-purpose-icon">
                <i className="bi bi-eye-fill"></i>
              </div>
            </div>

            <span className="purpose-small-title">OUR VISION</span>
            <h3>Vision</h3>
            <div className="purpose-divider"></div>

            <p>
              To nurture the children of IAF Air warriors into
              confident, capable and compassionate citizens -
              rooted in Indian values, committed to excellence
              and inspired to serve the nation with honour.
            </p>
          </div>

          <div className="purpose-image">
            <img
              src={vision}
              alt="Student representing the vision of Air Force School"
            />
          </div>

        </div>
      </div>

      {/* MISSION CARD */}
      <div className="col-lg-6">
        <div className="purpose-card mission-purpose-card animate-on-scroll animate-right">

          <div className="purpose-content">
            <div className="purpose-card-top">
              <div className="purpose-icon mission-purpose-icon">
                <i className="bi bi-bullseye"></i>
              </div>
            </div>

            <span className="purpose-small-title">OUR MISSION</span>
            <h3>Mission</h3>
            <div className="purpose-divider"></div>

            <p>
              Nurturing future citizens imbibing strong values,
              spirit of national service, integrity and a sense
              of responsibility.
            </p>
          </div>

          <div className="purpose-image">
            <img
              src={mission}
              alt="Students representing the mission of Air Force School"
            />
          </div>

        </div>
      </div>

    </div>
  </div>
</section>


    </main>
  );
};

export default History;
